import { render, staticRenderFns } from "./detail_train.vue?vue&type=template&id=6c899e64"
import script from "./detail_train.vue?vue&type=script&lang=js"
export * from "./detail_train.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports